<template>
<div class="chapter">
<div class="inner_page">
<h1 id="sigil_toc_id_5">Contents</h1>
<p class="firstleft"><a href="#/Text/acknowledg"><strong class="b">Acknowledgments</strong></a></p>
<p class="firstleft"><a href="#/Text/introduction"><strong class="b">Introduction: Why Postcolonial Conversations Matter</strong></a></p>
<blockquote>
<p class="firstleft"><a href="#/Text/introduction">Reflection on Postcolonial Friendship</a></p>
<p class="body"><em>Brian D. McLaren</em></p>
<p class="firstleft"><a href="#/Text/section1">The Importance of Postcolonial Evangelical Conversations</a></p>
<p class="body"><em>Steve Hu</em></p>
<p class="firstleft"><a href="#/Text/section2">A Response to the Postcolonial Roundtable</a></p>
<p class="left"><em>Promises, Problems and Prospects</em></p>
<p class="body"><em>Gene L. Green</em></p>
<p class="firstleft"><a href="#/Text/section3">The Postcolonial Challenge to Evangelicals</a></p>
<p class="body"><em>Editors</em></p>
<p class="firstleft"><a href="#/Text/section4">Prospects and Problems for Evangelical Postcolonialisms</a></p>
<p class="body"><em>Robert S. Heaney</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part1" title="Link target outside of Sample"><strong class="b">PART ONE: MISSION AND METANARRATIVE<br/>
<em class="i">ORIGINS AND ARTICULATIONS</em></strong></span></p>
<p class="firstleft"><span href="#/Text/intro1" title="Link target outside of Sample"><strong class="b">Introduction to Part One</strong></span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch1" title="Link target outside of Sample">1 From Good: “The Only Good Indian Is a Dead Indian”<br/>
    to Better: “Kill the Indian and Save the Man”<br/>
    to Best: “Old Things Pass Away and All Things Become White!”</span></p>
<p class="left">An American Hermeneutic of Colonization</p>
<p class="body"><em>L. Daniel Hawk and Richard L. Twiss</em></p>
<p class="firstleft"><span href="#/Text/ch2" title="Link target outside of Sample">2 North American Mission and Motive</span></p>
<p class="left">Following the Markers</p>
<p class="body"><em>Gregory Lee Cuéllar and Randy S. Woodley</em></p>
<p class="firstleft"><span href="#/Text/ch3" title="Link target outside of Sample">3 Postcolonial Feminism, the Bible and the Native Indian Women</span></p>
<p class="body"><em>Jayachitra Lalitha</em></p>
<p class="firstleft"><span href="#/Text/ch4" title="Link target outside of Sample">4 Converting a Colonialist Christ</span></p>
<p class="left">Toward an African Postcolonial Christology</p>
<p class="body"><em>Victor Ifeanyi Ezigbo and Reggie L. Williams</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part2" title="Link target outside of Sample"><strong class="b">PART TWO: THE STORIES BEHIND THE COLONIAL STORIES</strong></span></p>
<p class="firstleft"><span href="#/Text/intro2" title="Link target outside of Sample"><strong class="b">Introduction to Part Two</strong></span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch5" title="Link target outside of Sample">5 Tracing the Metanarrative of Colonialism and Its Legacy</span></p>
<p class="body"><em>Teri R. Merrick</em></p>
<p class="firstleft"><span href="#/Text/ch6" title="Link target outside of Sample">6 American Exceptionalism as Prophetic Nationalism</span></p>
<p class="body"><em>Kurt Anders Richardson</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part3" title="Link target outside of Sample"><strong class="b">PART THREE: REVISIONING EVANGELICAL THEOLOGY</strong></span></p>
<p class="firstleft"><span href="#/Text/intro3" title="Link target outside of Sample"><strong class="b">Introduction to Part Three</strong></span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch7" title="Link target outside of Sample">7 The Apocalypse of Colonialism</span></p>
<p class="left">Notes Toward a Postcolonial Eschatology</p>
<p class="body"><em>Christian T. Collins Winn and Amos Yong</em></p>
<p class="firstleft"><span href="#/Text/ch8" title="Link target outside of Sample">8 Jesus/Christ the Hybrid</span></p>
<p class="left">Toward a Postcolonial Evangelical Christology</p>
<p class="body"><em>Joya Colon-Berezin and Peter Goodwin Heltzel</em></p>
<p class="firstleft"><span href="#/Text/ch9" title="Link target outside of Sample">9 Recovering the Spirit of Pentecost</span></p>
<p class="left">Canon and Catholicity in Postcolonial Perspective</p>
<p class="body"><em>Megan K. DeFranza and John R. Franke</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part4" title="Link target outside of Sample"><strong class="b">PART FOUR: TRANSFORMING THE EVANGELICAL LEGACY</strong></span></p>
<p class="firstleft"><span href="#/Text/intro4" title="Link target outside of Sample"><strong class="b">Introduction to Part Four</strong></span></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch10" title="Link target outside of Sample">10 The Problem and Promise of Praxis in Postcolonial Criticism</span></p>
<p class="body"><em>Gilberto Lozano and Federico A. Roth</em></p>
<p class="firstleft"><span href="#/Text/ch11" title="Link target outside of Sample">11 Embracing the Other</span></p>
<p class="left">A Vision for Evangelical Identity</p>
<p class="body"><em>Kay Higuera Smith</em></p>
<p class="firstleft"><span href="#/Text/ch12" title="Link target outside of Sample">12 Healthy Leadership and Power Differences in the Postcolonial Community</span></p>
<p class="left">Two Reflections</p>
<p class="body"><em>Nicholas Rowe and Ray Aldred</em></p>
<p class="firstleft"><span href="#/Text/ch13" title="Link target outside of Sample">13 Christian Disciplines as Ways of Instilling God’s Shalom for Postcolonial Communities</span></p>
<p class="left">Two Reflections</p>
<p class="body"><em>Nicholas Rowe and Safwat Marzouk</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/part5" title="Link target outside of Sample"><strong class="b">PART FIVE: CLOSING THE CIRCLE</strong></span></p>
<p class="firstleft"><span href="#/Text/intro5" title="Link target outside of Sample"><strong class="b">Introduction to Part Five</strong></span></p>
<p class="body"><em>Joseph F. Duggan</em></p>
<blockquote>
<p class="firstleft"><span href="#/Text/ch14" title="Link target outside of Sample">14 Hosting a True Roundtable</span></p>
<p class="left">Dialogue Across Theological and Postcolonial Divides</p>
<p class="body"><em>Judith Oleson</em></p>
</blockquote>
<p class="firstleft"><span href="#/Text/benediction" title="Link target outside of Sample"><strong class="b">Benediction</strong></span></p>
<p class="body"><em>Gregory W. Carmer</em></p>
<p class="firstleft"><span href="#/Text/twiss" title="Link target outside of Sample"><strong class="b">Dr. Richard Twiss—a Remembrance</strong></span></p>
<p class="body"><em>Randy S. Woodley</em></p>
<p class="firstleft"><span href="#/Text/contribs" title="Link target outside of Sample"><strong class="b">Contributors’ Biographies</strong></span></p>
<p class="firstleft"><span href="#/Text/notes" title="Link target outside of Sample"><strong class="b">Notes</strong></span></p>
<p class="firstleft"><span href="#/Text/nsindex" title="Link target outside of Sample"><strong class="b">Name and Subject Index</strong></span></p>
<p class="firstleft"><span href="#/Text/scrindex" title="Link target outside of Sample"><strong class="b">Scripture Index</strong></span></p>
<p class="firstleft"><span href="#/Text/praise" title="Link target outside of Sample"><strong class="b">Praise for <em>Evangelical Postcolonial Conversations</em></strong></span></p>
<p class="firstleft"><span href="#/Text/editors" title="Link target outside of Sample"><strong class="b">About the Editors</strong></span></p>
<p class="firstleft"><span href="#/Text/moreIVP" title="Link target outside of Sample"><strong class="b">More Titles from InterVarsity Press</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5384ef66